module.exports = __webpack_public_path__ + "img/coming-soon.e17b0f4c.svg";